export default __webpack_public_path__ + "static/media/share-story-1.29d86689.png";